var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
import { __decorate, __metadata } from "tslib";
import { ElMessage } from 'element-plus';
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/hrgs/master/CompetencyMappingEnum';
import TMasterCompetencyMappingList from '@/core/types/entities/hrgs/master/competency-mapping/MasterCompetencyMappingList';
import ApiService from '@/core/services/ApiService';
import { Pagination } from '@/core/enums/Pagination';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    url: `${API_URL}/api/competencyunits`,
    position: `${API_URL}/api/positions`,
    getSchemeList: `${API_URL}/api/schemes`
};
let MasterCompetencyMappingModule = class MasterCompetencyMappingModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.modalFilterLoading = false;
        this.masterCompetencyMappingList = [];
        this.masterCompetencyMappingFormInput = {
            competencyMappingId: '',
            idJabatan: '',
            schemes: ['']
        };
        this.filterForm = {
            jabatan: '',
            schemes: ''
        };
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1,
            loading: false
        };
        this.jabatanOptions = [];
        this.schemesOptions = [];
        this.orderBy = null;
    }
    // SECTION
    // *GETTERS* //
    get getMasterCompetencyMappingList() {
        return this.masterCompetencyMappingList;
    }
    get getPaginationMasterCompetencyMappingList() {
        return this.pagination;
    }
    get getFilterFormMasterCompetencyMappingList() {
        return this.filterForm;
    }
    get getIsMasterCompetencyMappingListDataLoading() {
        return this.loading;
    }
    get getIsMasterCompetencyMappingListPaginationLoading() {
        return this.pagination.loading;
    }
    get getMasterCompetencyMappingJabatanOptionsList() {
        return this.jabatanOptions;
    }
    get getMasterCompetencyMappingSchemesOptionsList() {
        return this.schemesOptions;
    }
    get getMasterCompetencyMappingFormInput() {
        return this.masterCompetencyMappingFormInput;
    }
    get getCompetencyMappingModalLoading() {
        return this.modalFilterLoading;
    }
    // SECTION
    // *MUTATIONS* //
    [_a = Mutations.SET_MASTER_COMPETENCY_MAPPING_LIST](data) {
        const newFormattedArr = data.map((element) => {
            return new TMasterCompetencyMappingList(element);
        });
        this.masterCompetencyMappingList = newFormattedArr;
    }
    [_b = Mutations.SET_LOADING](state) {
        this.loading = state;
    }
    [_c = Mutations.SET_MODAL_LOADING](state) {
        this.modalFilterLoading = state;
    }
    [_d = Mutations.SET_PAGINATION_LOADING](state) {
        this.pagination.loading = state;
    }
    [_e = Mutations.SET_PAGINATION_CURRENT_PAGE_CHANGE](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.pagination.totalPageSize;
        const currentPage = data.currentPage || this.pagination.currentPage;
        this.pagination = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize),
            loading: false
        };
    }
    [_f = Mutations.SET_JABATANS_OPTIONS](payload) {
        const formattedOptions = payload.map((element) => {
            return {
                value: element.id,
                label: element.name
            };
        });
        this.jabatanOptions = formattedOptions;
    }
    [_g = Mutations.SET_SCHEMES_OPTIONS](payload) {
        const formattedOptions = payload.map((element) => {
            return {
                value: element.id,
                label: element.title,
                disabled: false
            };
        });
        this.schemesOptions = formattedOptions;
    }
    [_h = Mutations.SET_EDIT_LIST](payload) {
        this.masterCompetencyMappingFormInput = {
            competencyMappingId: payload,
            idJabatan: payload.positionId,
            schemes: payload.schemes.map((item) => {
                return item.id;
            })
        };
    }
    [_j = Mutations.SET_FILTER]({ position, scheme }) {
        this.filterForm = {
            jabatan: position !== null && position !== void 0 ? position : '',
            schemes: scheme !== null && scheme !== void 0 ? scheme : ''
        };
    }
    [_k = Mutations.RESET_MASTER_COMPETENCY_MAPPING_LIST_FILTER]() {
        this.filterForm = {
            jabatan: '',
            schemes: ''
        };
    }
    [_l = Mutations.CLEAR_FORM_INPUT]() {
        this.masterCompetencyMappingFormInput = {
            idJabatan: '',
            competencyMappingId: '',
            schemes: ['']
        };
    }
    [_m = Mutations.SET_ORDER](data) {
        this.orderBy = data;
    }
    // SECTION
    // *ACTIONS* //
    // *GET LIST
    [_o = Actions.GET_MASTER_COMPETENCY_MAPPING_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        const url = `${API_URLS.position}/${employeeID}/schemes/?`;
        const filter = `SearchValues=${this.filterForm.jabatan}&SearchValues=${this.filterForm.schemes}&`;
        const params = Object.assign({ ver: 'v1', pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO }, (this.orderBy && {
            orderBy: this.orderBy
        }));
        return new Promise((resolve, reject) => {
            this.context.commit(Mutations.SET_LOADING, true);
            this.context.commit(Mutations.SET_PAGINATION_LOADING, true);
            ApiService.get(`${url}${filter}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content.data;
                this.context.commit(Mutations.SET_MASTER_COMPETENCY_MAPPING_LIST, resData);
                this.context.commit(Mutations.SET_PAGINATION_CURRENT_PAGE_CHANGE, {
                    currentPage: params.pageNo,
                    pageSize: params.pageSize,
                    totalItems: data.data.result.content.totalRecords
                });
                resolve();
            })
                .catch((error) => {
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LOADING, false);
                this.context.commit(Mutations.SET_PAGINATION_LOADING, false);
            });
        });
    }
    // *DELETE ITEM LIST
    [_p = Actions.DELETE_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        const positionID = payload.positionID;
        const url = `${API_URLS.position}/${employeeID}/${positionID}/schemes`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.delete(url + `?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                }
                resolve(res.data.statusCode);
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed to delete competenct mapping.'
                });
                reject(error);
            });
        });
    }
    // *GET ITEM DETAIL
    [_q = Actions.GET_MASTER_COMPETENCY_MAPPING_LIST_DETAIL](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        const url = `${API_URLS.position}`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(url +
                `/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const data = response.data.result.content;
                this.context.commit(Mutations.SET_MASTER_COMPETENCY_MAPPING_LIST_DETAIL, data);
                resolve();
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    // *POST ITEM LIST
    [_r = Actions.POST_DATA]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        const params = {
            ver: 'v1'
        };
        const masterCompetencyMappingData = {
            schemeIds: this.masterCompetencyMappingFormInput.schemes
        };
        return new Promise((resolve, reject) => {
            this.context.commit(Mutations.SET_LOADING, true);
            ApiService.post(API_URLS.position +
                `/${employeeID}/${this.masterCompetencyMappingFormInput.idJabatan}/schemes?${new URLSearchParams(params).toString()}`, masterCompetencyMappingData)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject(res.data.result.isError);
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed to create competency mapping.'
                });
                reject(_response);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LOADING, false);
            });
        });
    }
    // *UPDATE ITEM LIST
    [_s = Actions.UPDATE_DATA]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        const params = {
            ver: 'v1'
        };
        const masterCompetencyMappingData = {
            schemeIds: this.masterCompetencyMappingFormInput.schemes
        };
        return new Promise((resolve, reject) => {
            this.context.commit(Mutations.SET_LOADING, true);
            ApiService.put(API_URLS.position +
                `/${employeeID}/${this.masterCompetencyMappingFormInput.idJabatan}/schemes?${new URLSearchParams(params).toString()}`, masterCompetencyMappingData)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed to update competency mapping.'
                });
                reject(_response);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LOADING, true);
            });
        });
    }
    // *GET POSITION OPTIONS
    [_t = Actions.GET_JABATANS_OPTIONS]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        const url = `${API_URLS.position}`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(url + `/${employeeID}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const data = response.data.result.content;
                this.context.commit(Mutations.SET_JABATANS_OPTIONS, data);
                resolve();
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    // *GET SCHEMA OPTIONS
    [_u = Actions.GET_SCHEMES_OPTIONS]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        const url = `${API_URLS.getSchemeList}`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(url + `/${employeeID}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const data = response.data.result.content.data;
                this.context.commit(Mutations.SET_SCHEMES_OPTIONS, data);
                resolve();
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    // *EXPORT COMPETENCY MAPPING LIST DATA (CREATE/CHANGE)
    [_v = Actions.EXPORT_COMPETENCY_MAPPING](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        const filter = `SearchValues=${this.filterForm.jabatan}&SearchValues=${this.filterForm.schemes}&`;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        this.context.commit(Mutations.SET_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/competencymapping/${payload}?${filter}${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                this.context.commit(Mutations.SET_LOADING, false);
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed download template.'
                });
                reject(error);
            });
        });
    }
    // *DOWNLOAD COMPETENCY MAPPING LIST DATA
    [_w = Actions.DOWNLOAD_COMPETENCY_MAPPING](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            fileName: (payload === null || payload === void 0 ? void 0 : payload.fileName) || ''
        };
        return new Promise((resolve, reject) => {
            ApiService.getBlob(`${API_URLS.url}/${employeeID}/competencymapping/download?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', params.fileName);
                document.body.appendChild(link);
                link.click();
                resolve();
            })
                .catch((error) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed download template.'
                });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_LOADING, false);
            });
        });
    }
    // *UPLOAD CHANGED COMPETENCY MAPPING DATA FILE
    [_x = Actions.UPLOAD_CHANGE_COMPETENCY_MAPPING](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = new FormData();
        formdata.append('fileUpload', payload.fileUpload);
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/competencymapping/changeupload?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed upload change competency mapping.'
                });
                reject(_response);
            });
        });
    }
    // *SUBMIT CHANGED COMPETENCY MAPPING DATA
    [_y = Actions.UPLOAD_SUBMIT_CHANGE_COMPETENCY_MAPPING](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = {
            request: payload.data
        };
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/competencymapping/changeupload/submit?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed submit upload change competency mapping.'
                });
                reject(_response);
            });
        });
    }
    // *UPLOAD CREATED COMPETENCY MAPPING DATA FILE
    [_z = Actions.UPLOAD_CREATE_COMPETENCY_MAPPING](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = new FormData();
        formdata.append('fileUpload', payload.fileUpload);
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/competencymapping/createupload?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed upload create competency mapping.'
                });
                reject(_response);
            });
        });
    }
    // *SUBMIT CHANGED COMPETENCY MAPPING DATA
    [_0 = Actions.UPLOAD_SUBMIT_CREATE_COMPETENCY_MAPPING](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = {
            request: payload.data
        };
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/competencymapping/createupload/submit?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed submit upload create competency mapping.'
                });
                reject(_response);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _m, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _o, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _p, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _q, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _r, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _s, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _t, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _u, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _v, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _w, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _x, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _y, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _z, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MasterCompetencyMappingModule.prototype, _0, null);
MasterCompetencyMappingModule = __decorate([
    Module
], MasterCompetencyMappingModule);
export default MasterCompetencyMappingModule;
